// Client-side email check shared by the two capture surfaces: the gated builder
// form (UrlForm, EmailGate on) and the post-hoc capture modal (EmailCapture).
// Naive on purpose — it's a UX hint, and the server stays authoritative
// (URI::MailTo::EMAIL_REGEXP plus a 320-char cap in
// QrCodesController#valid_creator_email?). One definition so the two arms of
// the same funnel can't validate, or word their rejection, differently.
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export function validateEmail(value) {
  const trimmed = value.trim()
  if (!trimmed) return "Enter an email so we can send you the code."
  if (!EMAIL_REGEX.test(trimmed)) return "That doesn't look like a valid email."
  return null
}
